import {
  amplitudeTrackEvent,
  captureSentryMessage,
} from '@airship-platform/airship-patterns';
import { RxDbBulkWriteError } from '../../rxdb/utils/rxDbDataService';
import {
  PricebookSyncError,
  type PricebookSyncDownload,
} from './pricebook.replication';

export const trackPricebookSyncDownload = (download: PricebookSyncDownload) =>
  amplitudeTrackEvent('Pricebook Sync Downloaded', {
    segment: download.segment,
    itemCount: download.itemCount,
    contentHash: download.contentHash ?? 'none',
    fetchMs: download.fetchMs,
    writeMs: download.writeMs,
  });

const causeDetail = (cause?: Error): Record<string, string | number> => {
  if (!cause) {
    return {};
  }

  return {
    causeName: cause.name,
    causeMessage: cause.message,
    ...(cause instanceof RxDbBulkWriteError
      ? {
          writeErrorCount: cause.errors.length,
          writeErrorSample: JSON.stringify(cause.errors[0] ?? null).slice(
            0,
            500
          ),
        }
      : {}),
  };
};

export const reportPricebookSyncFailure = (error: unknown) => {
  const staged = error instanceof PricebookSyncError ? error : undefined;
  const segment = staged?.segment ?? 'none';
  const stage = staged?.stage ?? 'manifest';

  amplitudeTrackEvent('Pricebook Sync Failed', { segment, stage });

  if (stage === 'not-built') {
    return;
  }

  captureSentryMessage({
    message: `Pricebook sync failed: ${stage} (${segment})`,
    level: 'error',
    tags: [
      { key: 'pricebook.sync.segment', value: segment },
      { key: 'pricebook.sync.stage', value: stage },
    ],
    context: {
      key: 'Pricebook Sync',
      detail: {
        segment,
        stage,
        ...staged?.detail,
        ...causeDetail(staged?.cause),
        error: `${error}`,
      },
    },
  });
};
